<template>
  <div>
    <v-alert
      v-if="!meta.is_edit"
      dense
      icon="mdi-information"
      colored-border
      border="left"
      class="bg-notif no-border"
      color="yellow darken-4"
    >
      <strong>INFORMASI PENTING</strong>
      <ul v-if="isBelumMulai" class="mt-1" style="padding-inline-start: 20px">
        <li>
          Pengisian laporan periode <strong>{{ mPendampinganPmo[kPertemuan] }}</strong> sudah tidak dapat dilakukan
          karena batas pengisian maksimal di tanggal 10 periode berikutnya.
        </li>
        <li>
          Instrumen laporan yang bisa di <strong>Set Selesai,</strong> hanyalah yang sudah mendapatkan respons dari PMO
          Daerah / PMO Pusat.
        </li>
      </ul>
      <ul v-else class="mt-1" style="padding-inline-start: 20px">
        <li>
          Pengisian laporan untuk periode <strong>{{ mPendampinganPmo[kPertemuan] }}</strong> belum dibuka.
        </li>
      </ul>
    </v-alert>
    <v-alert v-if="+$getDeepObj(pendampingan, 'meta.pendampingan_tahun') < 2023" class="bg-info" dense>
      <div class="body-1 font-weight-medium">Informasi Kategori Sekolah !</div>
      <div>
        <v-icon left color="indigo" class="mr-0">mdi-numeric-1-circle</v-icon>
        : Wajib menginputkan laporan PMO <span class="font-weight-medium">setiap bulan.</span>
      </div>
      <div>
        <v-icon left color="blue" class="mr-0">mdi-numeric-2-circle</v-icon>
        : Wajib menginputkan laporan PMO <span class="font-weight-medium">setiap 2 bulan sekali.</span>
      </div>
      <div>
        <v-icon left color="cyan" class="mr-0">mdi-numeric-3-circle</v-icon>
        : Wajib menginputkan laporan PMO <span class="font-weight-medium">setiap 3 bulan sekali.</span>
      </div>
    </v-alert>
    <v-row v-for="(item, id) in sekolah" :key="id">
      <v-col cols="12">
        <v-expansion-panels flat class="my-2" accordion>
          <v-expansion-panel>
            <v-expansion-panel-header class="py-0">
              <template v-slot:default="{ open }">
                <v-list-item class="px-0">
                  <v-list-item-content>
                    <v-row>
                      <v-col cols="12" md="4">
                        <v-list-item class="px-0">
                          <v-list-item-avatar color="blue">
                            <v-icon dark>mdi-office-building-outline</v-icon>
                          </v-list-item-avatar>
                          <v-list-item-content class="py-0 px-1">
                            <div class="blue--text">
                              {{ $getDeepObj(item, 'sekolah.data.nama') || '-' }}
                            </div>
                            <div class="black--text body-2">
                              <span class="font-weight-medium">NPSN : </span>
                              {{ $getDeepObj(item, 'sekolah.data.npsn') || '-' }}
                            </div>
                            <div v-if="item.k_kp_kategori_psp" class="black--text body-2">
                              <span class="font-weight-medium">Kategori: </span>
                              <v-icon left :color="kategoris[item.k_kp_kategori_psp]" class="mr-0">
                                mdi-numeric-{{ item.k_kp_kategori_psp }}-circle
                              </v-icon>
                            </div>
                          </v-list-item-content>
                        </v-list-item>
                      </v-col>
                      <v-col cols="12" md="3">
                        <v-list-item class="px-0">
                          <v-list-item-content class="py-0">
                            <v-list-item-title>
                              <v-label color="caption"><small>Informasi Laporan </small></v-label>
                            </v-list-item-title>
                            <div class="link black--text body-2">
                              <template v-if="isTidakTerlaksana(item)">
                                <v-icon left color="blue" small>mdi-alert-circle</v-icon>
                                {{
                                  $getDeepObj(
                                    item,
                                    `psp_kp_pa_sekolah_laporans.data.0.status_lengkap.rekap_sekolah${
                                      isMultiDasar ? '_dasar' : ''
                                    }.belum`
                                  )
                                }}
                                Laporan tidak perlu dikerjakan
                              </template>
                              <template
                                v-else-if="!$getDeepObj(item, 'psp_kp_pa_sekolah_laporans.data.0.status_lengkap')"
                              >
                                <v-icon left color="red" small>mdi-alert</v-icon>
                                <span class="font-weight-medium">Semua</span> Laporan belum dikerjakan
                              </template>
                              <template v-else>
                                <ul style="list-style: none" class="pa-0 ma-0">
                                  <li
                                    v-if="
                                      Number(
                                        $getDeepObj(
                                          item,
                                          `psp_kp_pa_sekolah_laporans.data.0.status_lengkap.rekap_sekolah${
                                            isMultiDasar ? '_dasar' : ''
                                          }.belum`
                                        )
                                      ) || 0 > 0
                                    "
                                  >
                                    <v-icon left color="red" small>mdi-alert</v-icon>
                                    <span class="font-weight-medium">
                                      {{
                                        $getDeepObj(
                                          item,
                                          `psp_kp_pa_sekolah_laporans.data.0.status_lengkap.rekap_sekolah${
                                            isMultiDasar ? '_dasar' : ''
                                          }.belum`
                                        )
                                      }}
                                    </span>
                                    Laporan belum dikerjakan
                                  </li>
                                  <li
                                    v-if="
                                      Number(
                                        $getDeepObj(
                                          item,
                                          `psp_kp_pa_sekolah_laporans.data.0.status_lengkap.rekap_sekolah${
                                            isMultiDasar ? '_dasar' : ''
                                          }.proses`
                                        )
                                      ) || 0 > 0
                                    "
                                  >
                                    <v-icon left color="info" small>mdi-alert-circle</v-icon>
                                    <span class="font-weight-medium">
                                      {{
                                        $getDeepObj(
                                          item,
                                          `psp_kp_pa_sekolah_laporans.data.0.status_lengkap.rekap_sekolah${
                                            isMultiDasar ? '_dasar' : ''
                                          }.proses`
                                        )
                                      }}
                                    </span>
                                    Laporan dalam proses pengerjaan
                                  </li>
                                  <li
                                    v-if="
                                      Number(
                                        $getDeepObj(
                                          item,
                                          `psp_kp_pa_sekolah_laporans.data.0.status_lengkap.rekap_sekolah${
                                            isMultiDasar ? '_dasar' : ''
                                          }.selesai`
                                        )
                                      ) || 0 > 0
                                    "
                                  >
                                    <v-icon left color="success" small>mdi-checkbox-marked-circle</v-icon>
                                    <span class="font-weight-medium">
                                      {{
                                        $getDeepObj(
                                          item,
                                          `psp_kp_pa_sekolah_laporans.data.0.status_lengkap.rekap_sekolah${
                                            isMultiDasar ? '_dasar' : ''
                                          }.selesai`
                                        )
                                      }}
                                    </span>
                                    Laporan sudah selesai
                                  </li>
                                </ul>
                              </template>
                            </div>
                          </v-list-item-content>
                        </v-list-item>
                      </v-col>
                      <v-col cols="12" md="2">
                        <v-list-item class="px-0">
                          <v-list-item-content class="py-0">
                            <v-list-item-title>
                              <v-label color="caption"><small>Status Laporan</small></v-label>
                            </v-list-item-title>
                            <v-list-item-subtitle class="link black--text body-2">
                              <v-chip
                                :color="
                                  WARNA_STATUS[
                                    isTidakTerlaksana(item)
                                      ? 'tidak'
                                      : $getDeepObj(
                                          item,
                                          'psp_kp_pa_sekolah_laporans.data.0.status_lengkap.status_sekolah'
                                        ) || 'belum'
                                  ]
                                "
                                dark
                                small
                              >
                                {{
                                  isTidakTerlaksana(item)
                                    ? 'Tidak ada pelaporan'
                                    : $titleCase(
                                        $getDeepObj(
                                          item,
                                          'psp_kp_pa_sekolah_laporans.data.0.status_lengkap.status_sekolah'
                                        ) || 'Belum'
                                      )
                                }}
                              </v-chip>
                            </v-list-item-subtitle>
                          </v-list-item-content>
                        </v-list-item>
                      </v-col>
                      <v-col cols="12" md="2">
                        <v-list-item class="px-0">
                          <v-list-item-content class="py-0">
                            <v-list-item-title class="blue--text">
                              {{ open ? 'Tampilkan Ringkas' : 'Tampilkan Semua' }}
                            </v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                      </v-col>
                    </v-row>
                  </v-list-item-content>
                </v-list-item>
              </template>
            </v-expansion-panel-header>
            <v-expansion-panel-content style="background-color: #FFF8ED;">
              <template v-if="isTerlaksana(item)">
                <v-list dense class="py-0 pt-5 mb-3" style="background-color: #FFF8ED;">
                  <v-list-item class="px-0">
                    <v-list-item-avatar color="orange">
                      <v-icon class="white--text">mdi-pencil</v-icon>
                    </v-list-item-avatar>
                    <v-list-item-content>
                      <v-row no-gutters>
                        <v-col cols="12" lg="9" class="my-auto">
                          <div style="font-size: 17px">
                            Anda sudah mengkonfirmasi untuk <strong>melakukan pendampingan</strong> pada periode ini.
                            Silahkan melengkapi semua laporan di bawah ini
                          </div>
                        </v-col>
                        <v-col cols="12" lg="3" class="text-right">
                          <div>
                            <v-btn outlined color="orange" class="white--text" @click="onBatalTerlaksana(item)">
                              Batal Kerjakan
                            </v-btn>
                          </div>
                        </v-col>
                      </v-row>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
                <v-list-item v-for="(instrumen, id) in instrumens" class="pl-0" :key="id">
                  <v-list-item-content class="pt-0 pb-3">
                    <v-divider v-if="id !== 0" class="mb-3" />
                    <template v-if="instrumen.grup === 'info' && isMultiDasar">
                      <div :key="instrumen.grup">
                        <v-row v-for="dasarKe in 1" :key="`${instrumen.grup}-${dasarKe}`">
                          <v-col cols="12" class="pb-0">
                            <v-divider v-if="dasarKe !== 1" />
                          </v-col>
                          <v-col cols="12" md="4">
                            <v-list-item class="ml-2 px-0">
                              <v-list-item class="px-0">
                                <v-list-item-content class="py-0">
                                  <v-list-item-title>
                                    <v-label color="caption">
                                      <small>Laporan {{ $getDeepObj(item, 'sekolah.data.nama') || '-' }}</small>
                                    </v-label>
                                  </v-list-item-title>
                                  <div class="black--text body-2 font-weight-medium">
                                    {{ instrumen.title }}
                                  </div>
                                </v-list-item-content>
                              </v-list-item>
                            </v-list-item>
                          </v-col>
                          <v-col cols="12" md="3">
                            <v-list-item class="px-0">
                              <v-list-item class="px-0">
                                <v-list-item-content class="py-0">
                                  <v-list-item-title>
                                    <v-label color="caption">
                                      <small>Informasi Laporan</small>
                                    </v-label>
                                  </v-list-item-title>
                                  <v-list-item-subtitle class="link black--text body-2">
                                    <ul style="list-style: none" class="pa-0 ma-0">
                                      <li
                                        v-if="
                                          $getDeepObj(
                                            getLaporanDasar(item.psp_kp_pa_sekolah_id, dasarKe),
                                            'status_lengkap.status_info'
                                          )
                                        "
                                      >
                                        <v-icon left color="success" small>mdi-checkbox-marked-circle</v-icon>
                                        Laporan Sudah Selesai
                                      </li>
                                      <li v-else>
                                        <v-icon left color="red" small>mdi-alert</v-icon>
                                        Laporan Belum Selesai
                                      </li>
                                    </ul>
                                  </v-list-item-subtitle>
                                </v-list-item-content>
                              </v-list-item>
                            </v-list-item>
                          </v-col>
                          <v-col cols="12" md="2">
                            <v-list-item class="px-0">
                              <v-list-item-content class="py-0">
                                <v-list-item-title>
                                  <v-label color="caption"><small>Status Laporan</small></v-label>
                                </v-list-item-title>
                                <v-list-item-subtitle class="link black--text body-2">
                                  <v-chip
                                    :color="
                                      WARNA_STATUS[
                                        $getDeepObj(
                                          getLaporanDasar(item.psp_kp_pa_sekolah_id, dasarKe),
                                          'status_lengkap.status_info'
                                        )
                                          ? 'selesai'
                                          : 'belum'
                                      ]
                                    "
                                    dark
                                    small
                                  >
                                    {{
                                      $getDeepObj(
                                        getLaporanDasar(item.psp_kp_pa_sekolah_id, dasarKe),
                                        'status_lengkap.status_info'
                                      )
                                        ? 'Selesai'
                                        : 'belum'
                                    }}
                                  </v-chip>
                                </v-list-item-subtitle>
                              </v-list-item-content>
                            </v-list-item>
                          </v-col>
                          <v-col cols="12" md="2">
                            <v-list-item class="px-0">
                              <v-list-item-content class="py-0">
                                <v-list-item-title>
                                  <v-label color="caption"><small>Aksi</small></v-label>
                                </v-list-item-title>
                                <v-list-item-subtitle v-if="meta.is_edit" class="link black--text body-2">
                                  <v-btn
                                    small
                                    depressed
                                    color="primary"
                                    @click="onKuisioner(item, instrumen.grup, dasarKe)"
                                  >
                                    <v-icon left>
                                      mdi-pencil
                                    </v-icon>
                                    {{
                                      $getDeepObj(
                                        getLaporanDasar(item.psp_kp_pa_sekolah_id, dasarKe),
                                        'status_lengkap.status_info'
                                      )
                                        ? 'Ubah Informasi'
                                        : 'Lengkapi'
                                    }}
                                  </v-btn>
                                </v-list-item-subtitle>
                                <v-list-item-subtitle v-else class="link black--text body-2">
                                  <v-btn
                                    small
                                    depressed
                                    color="primary"
                                    @click="onViewLaporan(item, instrumen.grup, dasarKe)"
                                  >
                                    <v-icon left>
                                      mdi-eye
                                    </v-icon>
                                    Lihat Detail
                                  </v-btn>
                                </v-list-item-subtitle>
                              </v-list-item-content>
                            </v-list-item>
                          </v-col>
                        </v-row>
                      </div>
                    </template>
                    <v-row
                      v-if="(instrumen.grup === 'info' && versi === 1) || Object.keys(grup).includes(instrumen.grup)"
                      :key="instrumen.grup"
                    >
                      <v-col cols="12" md="4">
                        <v-list-item class="ml-2 px-0">
                          <v-list-item-content class="py-0">
                            <v-list-item-title>
                              <v-label color="caption">
                                <small>Laporan {{ $getDeepObj(item, 'sekolah.data.nama') || '-' }}</small>
                              </v-label>
                            </v-list-item-title>
                            <div class="black--text body-2 font-weight-medium">
                              {{ instrumen.title }}
                            </div>
                          </v-list-item-content>
                        </v-list-item>
                      </v-col>
                      <v-col cols="12" md="3">
                        <v-list-item class="px-0">
                          <v-list-item class="px-0">
                            <v-list-item-content class="py-0">
                              <v-list-item-title>
                                <v-label color="caption">
                                  <small>Informasi Laporan</small>
                                </v-label>
                              </v-list-item-title>
                              <v-list-item-subtitle class="link black--text body-2">
                                <template
                                  v-if="
                                    !$getDeepObj(item, 'psp_kp_pa_sekolah_laporans.data.0.status_lengkap.rekap_grup')
                                  "
                                >
                                  <v-icon left color="red" small>mdi-alert</v-icon>
                                  <span class="font-weight-medium">Semua</span> Laporan belum dikerjakan
                                </template>
                                <template v-else-if="['info'].includes(instrumen.grup)">
                                  <ul style="list-style: none" class="pa-0 ma-0">
                                    <li
                                      v-if="
                                        $getDeepObj(
                                          item,
                                          `psp_kp_pa_sekolah_laporans.data.0.status_lengkap.status_info`
                                        )
                                      "
                                    >
                                      <v-icon left color="success" small>mdi-checkbox-marked-circle</v-icon>
                                      Laporan Sudah Selesai
                                    </li>
                                    <li v-else>
                                      <v-icon left color="red" small>mdi-alert</v-icon>
                                      Laporan Belum Selesai
                                    </li>
                                  </ul>
                                </template>
                                <template v-else>
                                  <ul style="list-style: none" class="pa-0 ma-0">
                                    <li
                                      v-if="
                                        Number(
                                          $getDeepObj(
                                            item,
                                            `psp_kp_pa_sekolah_laporans.data.0.status_lengkap.rekap_grup.${instrumen.grup}.belum`
                                          )
                                        ) || 0 > 0
                                      "
                                    >
                                      <v-icon left color="red" small>mdi-alert</v-icon>
                                      <span class="font-weight-medium">
                                        {{
                                          $getDeepObj(
                                            item,
                                            `psp_kp_pa_sekolah_laporans.data.0.status_lengkap.rekap_grup.${instrumen.grup}.belum`
                                          )
                                        }}
                                      </span>
                                      Laporan belum dikerjakan
                                    </li>
                                    <li
                                      v-if="
                                        Number(
                                          $getDeepObj(
                                            item,
                                            `psp_kp_pa_sekolah_laporans.data.0.status_lengkap.rekap_grup.${instrumen.grup}.proses`
                                          )
                                        ) || 0 > 0
                                      "
                                    >
                                      <v-icon left color="info" small>mdi-alert-circle</v-icon>
                                      <span class="font-weight-medium">
                                        {{
                                          $getDeepObj(
                                            item,
                                            `psp_kp_pa_sekolah_laporans.data.0.status_lengkap.rekap_grup.${instrumen.grup}.proses`
                                          )
                                        }}
                                      </span>
                                      Laporan dalam proses pengerjaan
                                    </li>
                                    <li
                                      v-if="
                                        Number(
                                          $getDeepObj(
                                            item,
                                            `psp_kp_pa_sekolah_laporans.data.0.status_lengkap.rekap_grup.${instrumen.grup}.selesai`
                                          )
                                        ) || 0 > 0
                                      "
                                    >
                                      <v-icon left color="success" small>mdi-checkbox-marked-circle</v-icon>
                                      <span class="font-weight-medium">
                                        {{
                                          $getDeepObj(
                                            item,
                                            `psp_kp_pa_sekolah_laporans.data.0.status_lengkap.rekap_grup.${instrumen.grup}.selesai`
                                          )
                                        }}
                                      </span>
                                      Laporan sudah selesai
                                    </li>
                                  </ul>
                                </template>
                              </v-list-item-subtitle>
                            </v-list-item-content>
                          </v-list-item>
                        </v-list-item>
                      </v-col>
                      <v-col cols="12" md="2">
                        <v-list-item class="px-0">
                          <v-list-item-content class="py-0">
                            <v-list-item-title>
                              <v-label color="caption"><small>Status Laporan</small></v-label>
                            </v-list-item-title>
                            <v-list-item-subtitle class="link black--text body-2">
                              <template v-if="['info'].includes(instrumen.grup)">
                                <v-chip
                                  :color="
                                    WARNA_STATUS[
                                      $getDeepObj(item, `psp_kp_pa_sekolah_laporans.data.0.status_lengkap.status_info`)
                                        ? 'selesai'
                                        : 'belum'
                                    ]
                                  "
                                  dark
                                  small
                                >
                                  {{
                                    $getDeepObj(item, `psp_kp_pa_sekolah_laporans.data.0.status_lengkap.status_info`)
                                      ? 'Selesai'
                                      : 'belum'
                                  }}
                                </v-chip>
                              </template>
                              <template v-else>
                                <v-chip
                                  :color="
                                    WARNA_STATUS[
                                      $getDeepObj(
                                        item,
                                        `psp_kp_pa_sekolah_laporans.data.0.status_lengkap.status_grup.${instrumen.grup}`
                                      ) || 'belum'
                                    ]
                                  "
                                  dark
                                  small
                                >
                                  {{
                                    $titleCase(
                                      $getDeepObj(
                                        item,
                                        `psp_kp_pa_sekolah_laporans.data.0.status_lengkap.status_grup.${instrumen.grup}`
                                      ) || 'belum'
                                    )
                                  }}
                                </v-chip>
                              </template>
                            </v-list-item-subtitle>
                          </v-list-item-content>
                        </v-list-item>
                      </v-col>
                      <v-col cols="12" md="2">
                        <v-list-item class="px-0">
                          <v-list-item-content v-if="meta.is_edit || isEditSaran(item, instrumen.grup)" class="py-0">
                            <v-list-item-title>
                              <v-label color="caption"><small>Aksi</small></v-label>
                            </v-list-item-title>
                            <v-list-item-subtitle class="link black--text body-2">
                              <template v-if="['info'].includes(instrumen.grup)">
                                <v-btn small depressed color="primary" @click="onKuisioner(item, instrumen.grup)">
                                  <v-icon left>
                                    mdi-pencil
                                  </v-icon>
                                  {{
                                    $getDeepObj(item, `psp_kp_pa_sekolah_laporans.data.0.status_lengkap.status_info`)
                                      ? 'Ubah Informasi'
                                      : 'Lengkapi'
                                  }}
                                </v-btn>
                              </template>
                              <template v-else>
                                <v-btn small depressed color="primary" @click="onKuisioner(item, instrumen.grup)">
                                  <v-icon left>
                                    mdi-pencil
                                  </v-icon>
                                  {{
                                    ($getDeepObj(
                                      item,
                                      `psp_kp_pa_sekolah_laporans.data.0.status_lengkap.status_grup.${instrumen.grup}`
                                    ) || 'belum') === 'selesai'
                                      ? 'Ubah Jawaban'
                                      : 'Lengkapi'
                                  }}
                                </v-btn>
                              </template>
                            </v-list-item-subtitle>
                          </v-list-item-content>
                          <v-list-item-content v-else-if="isSetSelesai(item, instrumen)" class="py-0">
                            <v-list-item-title>
                              <v-label color="caption"><small>Aksi</small></v-label>
                            </v-list-item-title>
                            <v-list-item-subtitle class="link black--text body-2">
                              <v-btn
                                small
                                depressed
                                color="primary"
                                @click="onSelesai({ data: item, grup: instrumen.grup })"
                              >
                                <v-icon left>
                                  mdi-check
                                </v-icon>
                                Set Selesai
                              </v-btn>
                            </v-list-item-subtitle>
                          </v-list-item-content>
                          <v-list-item-content v-else class="py-0">
                            <v-list-item-title>
                              <v-label color="caption"><small>Aksi</small></v-label>
                            </v-list-item-title>
                            <v-list-item-subtitle class="link black--text body-2">
                              <v-btn small depressed color="primary" @click="onViewLaporan(item, instrumen.grup)">
                                <v-icon left>
                                  mdi-eye
                                </v-icon>
                                Lihat Detail
                              </v-btn>
                            </v-list-item-subtitle>
                          </v-list-item-content>
                        </v-list-item>
                      </v-col>
                    </v-row>
                  </v-list-item-content>
                </v-list-item>
              </template>
              <template v-else-if="isTidakTerlaksana(item)">
                <v-list dense class="py-0 pt-5 mb-3" style="background-color: #FFF8ED;">
                  <v-list-item class="px-0">
                    <v-list-item-avatar color="orange">
                      <v-icon class="white--text">mdi-pencil</v-icon>
                    </v-list-item-avatar>
                    <v-list-item-content>
                      <v-row no-gutters>
                        <v-col cols="12" lg="9" class="my-auto">
                          <div style="font-size: 17px">
                            Anda sudah mengkonfirmasi untuk <strong>tidak melakukan pendampingan</strong> pada periode
                            ini. Jika Anda ingin menyatakan melakukan pendampingan pada periode ini, silakan klik tombol
                            <strong>Kerjakan Laporan</strong> disamping.
                          </div>
                        </v-col>
                        <v-col cols="12" lg="3" class="text-right">
                          <div>
                            <v-btn outlined color="orange" class="white--text" @click="onTerlaksana(item)">
                              Kerjakan Laporan
                            </v-btn>
                          </div>
                        </v-col>
                      </v-row>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </template>
              <template v-else>
                <v-list dense class="py-0 pt-3" style="background-color: #FFF8ED;">
                  <v-list-item>
                    <v-list-item-avatar color="orange">
                      <v-icon class="white--text">mdi-pencil</v-icon>
                    </v-list-item-avatar>
                    <v-list-item-content>
                      <v-row no-gutters>
                        <v-col cols="12" lg="9" class="my-auto">
                          <div style="font-size: 17px">
                            Apakah Anda melakukan pendampingan terhadap sekolah pada periode ini ?
                          </div>
                        </v-col>
                        <v-col cols="12" lg="3" class="text-right">
                          <div>
                            <v-btn
                              :disabled="!meta.is_edit"
                              color="orange"
                              class="white--text"
                              @click="onKonfirmasiPelaksanaan(item)"
                            >
                              <v-icon left>mdi-pencil</v-icon>Kofirmasi
                            </v-btn>
                          </div>
                        </v-col>
                      </v-row>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </template>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-col>
    </v-row>
    <base-modal-full ref="modal" title="Konfirmasi Pelaksanaan Pendampingan" @save="onKonfirmasiPelaksaanSave">
      <form-pelaksanaan ref="pelaksanaan" :init-value="formulir.init" :sekolah="formulir.sekolah" />
    </base-modal-full>
  </div>
</template>

<script>
import FormPelaksanaan from '../formulir/Pelaksanaan';
import { mapActions } from 'vuex';

export default {
  name: 'DetailPmo',
  components: { FormPelaksanaan },
  props: {
    sekolah: {
      type: Array,
      default: () => [],
    },
    dasars: {
      type: Object,
      default: () => {},
    },
    grup: {
      type: Object,
      default: () => {},
    },
    kPertemuan: {
      type: Number,
      required: true,
    },
    versi: {
      type: [Number, String],
      default: 2,
    },
    meta: {
      type: [Object, Array],
    },
    current: {
      type: Object,
    },
    mPendampinganPmo: {
      type: Object,
    },
    pendampingan: {
      default: () => {},
    },
    pendampingans: {
      type: Object,
    },
  },
  data() {
    return {
      WARNA_STATUS: {
        tidak: 'orange',
        belum: 'error',
        proses: 'info',
        selesai: 'success',
      },
      kategoris: {
        1: 'indigo',
        2: 'blue',
        3: 'cyan',
      },
      formulir: {},
    };
  },
  computed: {
    isMultiDasar() {
      return [2, 3].includes(this.versi);
    },

    isBelumMulai() {
      return this.current['pendampingan_ke_pmo'] === 5 || this.kPertemuan < this.current['pendampingan_ke_pmo'];
    },

    instrumens() {
      let result = [
        { title: 'Informasi Dasar', grup: 'info' },
        { title: 'Pertanyaan Dasar', grup: 'dasar' },
        { title: 'A. Sumber Daya Manusia (SDM)', grup: 'sdm' },
        { title: 'B. Anggaran', grup: 'anggaran' },
        { title: 'C. Teknologi', grup: 'teknologi' },
        { title: 'D. Kegiatan Pembelajaran', grup: 'pembelajaran' },
        { title: 'E. Dukungan Pemerintah Daerah', grup: 'pemda' },
        { title: 'F. Dukungan Internal Sekolah', grup: 'internal' },
        { title: 'G. Kondisi Mendesak', grup: 'mendesak' },
        { title: 'H. Lainnya', grup: 'lain' },
      ];

      if (+this.versi === 3) {
        result = [
          { title: 'Informasi Dasar', grup: 'info' },
          { title: 'Tahapan Perencanaan dalam Implementasi Kurikulum Merdeka di Satuan Pendidikan', grup: 'rencana' },
          {
            title: 'Tahapan Pelaksanaan Pembelajaran dalam Implementasi Kurikulum Merdeka di Satuan Pendidikan',
            grup: 'pelaksanaan',
          },
          {
            title: 'Efektivitas kepemimpinan Kepala Sekolah sebagai Pemimpin Pembelajaran di Sekolah',
            grup: 'efektivitas',
          },
          { title: 'A. Sumber Daya Manusia (SDM)', grup: 'sdm' },
          { title: 'B. Anggaran', grup: 'anggaran' },
          { title: 'C. Teknologi', grup: 'teknologi' },
          { title: 'D. Kegiatan Pembelajaran', grup: 'pembelajaran' },
          { title: 'E. Dukungan Pemerintah Daerah', grup: 'pemda' },
          { title: 'F. Dukungan Internal Sekolah', grup: 'internal' },
          { title: 'G. Kondisi Mendesak', grup: 'mendesak' },
          { title: 'H. Lainnya', grup: 'lain' },
        ];
      }

      return result;
    },
  },
  methods: {
    ...mapActions('diklatPa', ['updateTerlaksana']),

    getLaporanDasar(id, dasarKe) {
      if (!this.dasars[id]) {
        return {};
      }

      if (this.kPertemuan === 14) {
        const laporans = this.dasars[id].filter((dasar) => +dasar.pendampingan_ke === 14) || [];
        const pendampinganKe14 = laporans[0] || {};

        if (this.$getDeepObj(pendampinganKe14, 'status_lengkap.status_info')) {
          return { status_lengkap: { status_info: true } };
        }

        return {};
      }

      const laporan = this.dasars[id].filter((dasar) => +dasar.dasar_ke === dasarKe) || [];
      return laporan[0] || {};
    },

    isSetSelesai(item, instrumen) {
      const pspKpPaSekolahLaporans = this.$getDeepObj(item, 'psp_kp_pa_sekolah_laporans.data') || [];
      const pspKpPaSekolahLaporanId = this.$getDeepObj(pspKpPaSekolahLaporans[0], 'psp_kp_pa_sekolah_laporan_id');
      const editSelesai = this.$getDeepObj(this.meta, `edit_selesai.${pspKpPaSekolahLaporanId}`) || [];

      return editSelesai.includes(instrumen.grup);
    },

    isEditSaran(item, grup) {
      const pspKpPaSekolahLaporans = this.$getDeepObj(item, 'psp_kp_pa_sekolah_laporans.data') || [];
      const pspKpPaSekolahLaporanId = this.$getDeepObj(pspKpPaSekolahLaporans[0], 'psp_kp_pa_sekolah_laporan_id');
      const editSaran = this.$getDeepObj(this.meta, `edit_saran.${pspKpPaSekolahLaporanId}`) || [];

      return editSaran.includes(grup);
    },

    isTerlaksana(sekolah = {}) {
      const pspKpPaSekolahLaporan = this.$getDeepObj(sekolah, 'psp_kp_pa_sekolah_laporans.data.0') || {};
      return [1].includes(pspKpPaSekolahLaporan.is_terlaksana_pmo);
    },

    isTidakTerlaksana(sekolah) {
      const pspKpPaSekolahLaporan = this.$getDeepObj(sekolah, 'psp_kp_pa_sekolah_laporans.data.0') || {};
      return [0].includes(pspKpPaSekolahLaporan.is_terlaksana_pmo);
    },

    onKonfirmasiPelaksanaan(sekolah) {
      const pendampingans = Object.values(Object.assign({}, this.pendampingans || {}));
      const pendampinganAwal = pendampingans[0] || {};
      const pendampinganPeriode = this.pendampingans[this.kPertemuan] || {};

      let pendampingan = pendampinganAwal;
      if (pendampinganAwal.psp_profil_id_pa !== pendampinganPeriode.psp_profil_id_pa) {
        pendampingan = pendampinganPeriode;
      }

      pendampingan.id = pendampinganPeriode.id;
      pendampingan.pendampingan_ke = pendampinganPeriode.pendampingan_ke;

      this.$set(this.formulir, 'init', null);
      this.$set(this.formulir, 'sekolah', sekolah || {});
      this.$set(this.formulir, 'pendampingan', pendampingan);

      this.$refs.modal.open();
      this.$nextTick(() => {
        this.$set(this.formulir, 'init', {
          jadwal: this.mPendampinganPmo[this.kPertemuan],
          ptk: this.$getDeepObj(pendampingan, 'psp_profil_pa.data.ptk.data') || {},
        });
        this.$refs.pelaksanaan.reset();
      });
    },

    onKonfirmasiPelaksaanSave() {
      const id = this.$getDeepObj(this.formulir, 'pendampingan.id') || '';
      const sekolah_id = this.$getDeepObj(this.formulir, 'sekolah.psp_kp_pa_sekolah_id') || '';
      const params = this.$refs.pelaksanaan.getValue();

      if (!Object.keys(params).length) {
        this.$refs.modal.loading = false;
        this.$error('Anda belum memilih status pendampingan sekolah');
        return;
      }

      this.updateTerlaksana({ id, sekolah_id, params })
        .then(() => {
          this.$refs.modal.close();
          this.$success('Berhasil disimpan');
          this.$emit('reload', this.kPertemuan);
        })
        .catch(() => {
          this.$refs.modal.loading = false;
        });
    },

    onBatalTerlaksana(data) {
      const pendampingan = this.$getDeepObj(this.pendampingans, `${this.kPertemuan}`) || null;
      const id = this.$getDeepObj(pendampingan, 'id') || '';
      const sekolah_id = this.$getDeepObj(data, 'psp_kp_pa_sekolah_id') || '';
      const sekolah = this.$getDeepObj(data, 'sekolah.data') || {};
      const params = { is_terlaksana_pmo: 0 };

      this.$confirm(`Anda ingin menyatakan <strong>tidak melakukan pendampingan</strong> untuk ${sekolah.nama} ?`).then(
        () => {
          this.updateTerlaksana({ id, sekolah_id, params })
            .then(() => {
              this.$refs.modal.close();
              this.$success('Berhasil disimpan');
              this.$emit('reload', this.kPertemuan);
            })
            .catch(() => {
              this.$refs.modal.loading = false;
            });
        }
      );
    },

    onTerlaksana(data) {
      const pendampingan = this.$getDeepObj(this.pendampingans, `${this.kPertemuan}`) || null;
      const id = this.$getDeepObj(pendampingan, 'id') || '';
      const sekolah_id = this.$getDeepObj(data, 'psp_kp_pa_sekolah_id') || '';
      const sekolah = this.$getDeepObj(data, 'sekolah.data') || {};
      const params = { is_terlaksana_pmo: 1 };

      this.$confirm(`Anda ingin menyatakan <strong>melakukan pendampingan</strong> untuk ${sekolah.nama} ?`).then(
        () => {
          this.updateTerlaksana({ id, sekolah_id, params })
            .then(() => {
              this.$refs.modal.close();
              this.$success('Berhasil disimpan');
              this.$emit('reload', this.kPertemuan);
            })
            .catch(() => {
              this.$refs.modal.loading = false;
            });
        }
      );
    },

    onKuisioner(item, grup, dasarKe) {
      this.$emit('onKuisioner', { data: item, grup, dasarKe, isEditSaran: this.isEditSaran(item, grup) });
    },

    onSelesai(arg) {
      this.$emit('onSelesai', arg);
    },

    onViewLaporan(data, grup, dasarKe) {
      const mInstrumen = this.$arrToObj(this.instrumens, 'grup');
      let title = mInstrumen[grup]['title'].split(' ');
      title.splice(0, 1);
      let retitle = grup === 'info' && dasarKe ? `Informasi Dasar Kegiatan ${dasarKe}` : title.join(' ');

      const options = {
        form: 'FormKuisioner',
        title: `Lihat Laporan PMO - ${retitle}`,
      };

      this.$emit('view', { data, grup, options, dasarKe });
    },
  },
};
</script>

<style scoped></style>
